
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-09-07-r3f-bezier-curves-nodes",
      function () {
        return require("private-next-pages/blogs/2025-09-07-r3f-bezier-curves-nodes/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-09-07-r3f-bezier-curves-nodes"])
      });
    }
  